import React from 'react'
import { useState , useEffect } from 'react';
import { TouchableOpacity } from 'react-native-web';
import { useNavigate } from 'react-router-dom';
import { InvitationModal ,SelectAppointmentType  } from 'tutorapp-components';
import { useDispatch } from 'react-redux'
import { createFamilyAppointment } from '../redux/actions/familyAppointmentActions';
import { createSchoolAppointment } from '../redux/actions/schoolAppointmentActions';
import { resetFamilyAppointmentState } from '../redux/actions/familyAppointmentActions';
import { resetSchoolAppointmentState } from '../redux/actions/schoolAppointmentActions';
import { useSelector } from 'react-redux';
import { setAppointmentType } from '../redux/actions/familyPresetValuesActions';
import { setSchoolAppointmentType } from '../redux/actions/schoolPresetValuesActions';


export default function SelectAppointmentTypeScreen() {


    const dispatch = useDispatch()
      
    const [modalVisible, setModalVisible] = useState(false);
      const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
      const showschool = selectedFranchise.country == 'UK'
    
    const navigate = useNavigate()



      useEffect(() => {
    
        dispatch(resetFamilyAppointmentState())
        dispatch(resetSchoolAppointmentState())
    
      }, []);

     const icons = {
        backarrow: "./images/ic_back.svg",
        address: "./images/ic_tutoring_address.svg",
        repeat: "./images/ic_repeat.svg",
        sessionappointment: "./images/ic_sessionappointment.svg",
        close: "./images/ic_close.svg",
        progress: "./images/ic_1.svg",
        family: "./images/ic_families.svg",
        school: "./images/ic_schools.svg",
        familynext: "./images/ic_families_next.svg",
        schoolnext: "./images/ic_schools_next.svg"
      };

      //navigate to session fill details page
    const  handlefamily = () => {
      dispatch(createFamilyAppointment({appointment_type : 0}))
      dispatch(setAppointmentType({appointment_type : 0}))
     navigate("/filldetails") }

  //navigate to school fill details page
    const handleschool = () => {
      dispatch(createSchoolAppointment({appointment_type : 1}))
      dispatch(setSchoolAppointmentType({appointment_type : 1}))

    navigate("/schoolfilldetails")}

  const handleselectionclose = () =>{
    
    navigate("/MyAppointment")
  }


  return (
    <div><SelectAppointmentType handleselectionclose={handleselectionclose} onSelectFamily= {handlefamily} showschool={showschool} onSelectSchool={handleschool} icons ={icons}/>
     
    
    <TouchableOpacity onPress={() => setModalVisible(true)} >
      </TouchableOpacity>

      {/* Pass Props to Control the Modal */}
      <InvitationModal isVisible={modalVisible} onClose={() => setModalVisible(false)} />

    
    </div>

    
  )
}
